export const environment = {
  production: false,
  //API标准格式形如：http://xxx.xxx.xxx.xxx/  （注意最后斜杠）

  //#region  seeker基础平台微服务api地址配置区域 192.168.10.106:8021
  isSaasLogin: false,
  ftpStaticFileUrl: "",
  seekerWebAPI: "http://192.168.10.96:19000/sw-basic-cloud/",          //基础平台微服务api

  fileWebAPI: "http://192.168.10.96:19000/sw-file-cloud/",           //文件处理微服务api

  activitiWebAPI: "http://192.168.10.96:19000/sw-activiti-cloud/",     //工作流微服务api

  scheduleWebApi: "http://192.168.10.96:19000/sw-scheduler-cloud/",   //任务调度微服务api

  ruleWebApi: "http://192.168.10.96:19000/sw-rule-cloud/",            //规则引擎微服务api

  webSocketApi: "ws://192.168.10.210:8041/",                       //消息队列

  smsWebAPI: "http://192.168.10.210:8021/",                      //短信验证码发送服务api   

  esWebAPI: "http://192.168.10.96:19000/sw-es-cloud/",                 //es全文检索服务

  saasWebAPI: "http://192.168.10.96:19000/sw-saas-cloud/",                      //saas租户管理服务api

  saasPortalUrl: "",                  //SaaS门户网站访问地址

  staticFileUrl: "http://192.168.10.96:9999/",      //静态资源文件web站点

  onlineOfficeWebAPI: "http://192.168.10.210:9999/",            //文件在线编辑服务api

  iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",            //openseadragon大图预览插件

  uploadDirectory: "swseeker",                                 //文件上传目录（以项目分文件夹存储）

  webSoketApi: "ws://192.168.10.210:8041/",                   //消息队列   

  //#endregion

  //#region 智慧博物馆业务产品领域微服务api地址配置区域
  
  hthWebAPI: "http://192.168.10.96:19000/sw-hth-cloud/",

  utcrWebAPI:"http://192.168.10.96:19000/sw-utcr-cloud/",

  ossWebAPI:"http://192.168.10.96:19000/sw-oss-cloud/",

  poiWebAPI: "http://192.168.10.96:19000/sw-poi-cloud-utcr/",               //积分微服务api
  
  societyWebAPI: "http://192.168.10.96:19000/sw-utcr-cloud/",             
  
  trmWebAPI: "http://192.168.10.96:19000/sw-trm-cloud-mk/",               //票务预约服务api

  //actWebAPI: "http://192.168.10.96:19000/sw-act-cloud-mk/",               //活动预约服务api
  actWebAPI: "http://192.168.10.96:19000/sw-act-cloud-cjy/",               //活动预约服务api


  drmWebAPI: "http://192.168.10.96:19000/sw-drm-cloud/",               //数字资源微服务api

  expWebAPI: "http://192.168.10.96:19000/sw-exp-cloud/",               //讲解员微服务api

  exhWebAPI: 'http://192.168.10.96:19000/sw-exh-cloud/',

  ckfWebAPI: 'http://192.168.10.96:19000/sw-ckf-gx-mk/',              //藏品服务api

  oaWebAPI: 'http://192.168.10.96:19000/sw-oa-hq/',                    //协同办公服务api

  vipWebAPI: "http://192.168.10.96:19000/sw-vip-cloud/", 

  volWebAPI: "http://192.168.10.96:19000/sw-vol-cloud-dss/",

  cmsWebAPI: "http://192.168.10.96:19000/sw-cms-cloud-utcr/",

  qrCodeWebAPI: 'https://utcr.cncis.com.cn/', //活动预约、参观预约、特展预约海报二维码服务api

  cosWebAPI: "http://192.168.10.96:19000/sw-oa-cloud/",

  exhMapKey: '56FBZ-IAA34-YK6UW-DOZ6C-GEN3J-6KFGV',//EXH 腾讯地图key值

  actMapKey: '53EBZ-M2TRU-MUDVV-BQ7JT-EQY62-ALFAI',//ACT 腾讯地图key值

  trmMapKey: 'QIRBZ-HTQRF-CXZJ7-JW3AR-3C7W7-MKBBZ',//TRM 腾讯地图key值
  
  //#endregion

  //#region 项目基本属性配置区域
  //#region 逻辑交互配置区

  encryptedPassword: false,                                     //是否加密密码

  multiTenancy: false,                                          //是否开启多租户管理模式

  systemCode: 'DYZ_UTCR',                                        //系统编号（默认不填，multiTenancy为false必填）

  isVcode: true,                                               //登录界面是否有验证码,默认需要验证码,值为true

  isSliderCode: false,                                          //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false

  isRelateDingTalk: false,                                      //是否有与钉钉相关的业务

  dingTalkAgentId: "",                                          //代理id,与钉钉同步的接口

  syncToUserResource: false,                                     //在文件上传组件中出现 ‘同步至数字资源’ 按钮

  resourceMark: false,                                          //数字资源是否有图像标注功能

  enbaleCustomLayout: true,                                     //工作台是否开启自定义布局

  isLoadAllMenu: false,                                         //是否按模块加载所有子级菜单，默认为false

  singleTab: false,                                              //是否单页签交互，默认为false（即多tab页签交互）

  tabNumber: 50,                                                //tab标签页最多显示数量（singleTab为false有效）

  singleMenu: false,                                             //头部是否用所有门户替换一级菜单

  openDefaultMenu: true,                                        //是否打开第1个菜单：默认为false

  isSwitchSkin: false,                                         //header头部右上角是否可切换项目皮肤，默认为true 显示（即可切换项目皮肤），false不显示（不能切换）

  defaultPortal: "/sw/console",                                //默认工作门户，配置的此路由对应的路由文件中要加上 canDeactivate: [SwUnfocusGuardService]，才能实现从首页离开刷新左侧菜单

  fullScreen: "/ckf/CulResourceQuery,/ckf/CulResourceSearch,/oa/InitiationProcess,/oa/ToDoProcess,/oa/CompletionProcess,/oa/PublishedProcess,/oa/ProcessStatistics,/drm/CommonResourceQuery,/drm/ResourceCollections,/drm/ResouceApplyQuery,/sw/console,",                                    //需要全屏展示页面集,用逗号隔开

  hideSingleTab: "/trm/console,/act/console,/drm/console,/ckf/console,/ckf/CulResourceQuery,/hth/console",      //隐藏单页签的页面集，用逗号隔开，只有在 singleTab 为 true 的前提下才生效
  //#endregion 逻辑交互配置区

  enableSsoLogin: false,                                        //启用ssoLogin登录（默认false）

  ssoTokenName: "Zxy",                                          //SSo登录配置的token名，根据约定动态更改

  defaultLanguage: "",                                          //国际化默认语言版本,zh-CN表示中文；en-US表示英文; 为空字符串或为null隐藏国际化功能，不能切换

  projectName: "文明跑运营管理平台",                                //系统名称，打包编译后中文会进行Unicode编码

  customerName: "文明跑运营管理平台",                                       //客户名称，打包编译后中文会进行Unicode编码


  projectLogo: "", //头部左侧背景图，当projectLogo为空时，显示projectName

  // projectLogo: "/assets/Theme/default/img/logo.png",           //头部左侧背景图，当projectLogo为空时，显示projectName

  projectLogoWidth: "240",                                     //当projectLogo不为空时，图片的宽度(该宽度严格为图片的宽度，高度默认值26px)

  loginStyle: 1,                                                //登录页风格，默认为1：表示竖版（推荐）；2：表示横版

  loginBackGround: "/assets/Theme/default/img/login-bg.jpg",   //登录页背景图

  favoriteIco: "/favicon.ico",                                 //系统ico图标/favicon.ico

  coptyRight: ""  //版权相关声明

  // coptyRight: "版权所有 © 2019-2025 &nbsp;武汉数文科技有限公司 &nbsp; 技术支持：武汉数文科技有限公司 &nbsp; 建议浏览器：chrome/360极速浏览器"  //版权相关声明
  //#endregion

};



